import VXEStore from './store';
export const hooks = new VXEStore();
